module.exports = require('./lib/effects')


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/redux-saga/effects.js
 ** module id = 26
 ** module chunks = 0
 **/